import React from 'react';
import { Box, Typography, useTheme } from '@nextiva/next-ui-components';

interface LaunchpadHeaderProps {
  subtitle: string;
  title: string;
}

export const LaunchpadHeader = ({
  title = '',
  subtitle = '',
}: LaunchpadHeaderProps) => {
  const theme = useTheme();

  return (
    <Box>
      {title.length ? (
        <Typography
          variant="h4"
          sx={{ color: theme.palette.secondary.contrastText, mb: '8px' }}
        >
          {title}
        </Typography>
      ) : null}

      {subtitle.length ? (
        <Typography variant="body1" sx={{ color: theme.palette.blueGrey.A600 }}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
};
